import Entity from '../entity'

export default class Configuration extends Entity<number>{
    tab: string;
    name: string;
    value: string;
}


